
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"138","height":"123","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".5","fill-rule":"evenodd","clip-rule":"evenodd","d":"M70.432 0C105.498 0 138 23.929 138 58.788 138 95.077 106.937 123 70.432 123 33.11 123 0 95.888 0 58.788 0 23.085 34.516 0 70.432 0z","fill":"#B9ECC7"}}),_c('circle',{attrs:{"cx":"69","cy":"62","r":"25.5","stroke":"#33AA54"}}),_c('path',{attrs:{"d":"M66.5 71l-.707.707.707.707.707-.707L66.5 71zm16.707-15.293a1 1 0 00-1.414-1.414l1.414 1.414zm-26.414 7l9 9 1.414-1.414-9-9-1.414 1.414zm10.414 9l16-16-1.414-1.414-16 16 1.414 1.414z","fill":"#33AA54"}})])
          )
        }
      }
    